<template>
  <div>
    <h3 class="text-c">支付成功</h3>
    <van-icon name="passed" color="#07c160" size="60" />
    <p class="text-c">
      请您缴费后在
      <span style="color: #ff976a">15分钟内</span>
      离场，否则将会重新计费！
    </p>
  </div>
</template>

<script>
export default {
  props: {

  },
  data () {
    return {

    };
  },
  components: {

  },
  computed: {

  },
  watch: {

  },
  created () {

  },
  mounted () {

  },
  methods: {

  },
};
</script>

<style scoped lang="less">
.text-c {
  text-align: center;
  margin-top: 40px;
  font-size: 20px;
  padding: 0 20px;
}
</style>
